module.exports = __webpack_public_path__ + "static/slide5-77dd20c020bdc9d64d816fdbfd404047.jpg";